import { createApp } from 'vue';
import App from './App.vue'
import router from "./router";
import store from "./store";
import { appAxios, appAxiosAdmin, appAxiosTourscope, appAxiosKolayrez,appAxiosOther } from "@/utils/appAxios";
import { createDataTable } from "@/utils/createDataTable";
import { searchColumnArray } from "@/utils/searchColumnArray";
import { searchArray } from "@/utils/searchArray";
import { orderByArray } from "@/utils/orderByArray";
import { turkishReplaces } from "@/utils/turkishReplaces";
import { isError } from "@/utils/isError";
import { dateFormat } from "@/utils/dateFormat";
import { uniqueid } from "@/utils/uniqueid";
import loadArea from './components/loadArea'
import dataTable from "./components/dataTable/dataTable.vue";
import cardHead from './components/cardHead.vue'
import formGroup from './components/formGroup/formGroup.vue'
import formGroupTag from './components/formGroup/formGroupTag.vue'
import searchSelect from './components/formGroup/searchSelect.vue'
import Button from './components/button.vue'
import modal from "@/components/modal";
import { ValidationProvider, Form, Field, ErrorMessage, configure } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import { defineRule } from 'vee-validate';
import { all as AllRules } from '@vee-validate/rules';
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import Maska from 'maska';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css"

import { formatPrice } from "@/utils/formatPrice";
Object.keys(AllRules).forEach(rule => {
  defineRule(rule, AllRules[rule]);
});

defineRule('email', (value) => {
  if (!value || !value.length) return true;
  const wildcardEmailRegex = /^[\w.*+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return wildcardEmailRegex.test(value) || 'Geçerli bir e-posta adresi giriniz';
});
import tr from '@vee-validate/i18n/dist/locale/tr.json';
configure({
  generateMessage: localize({ tr })
});
setLocale("tr");


import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import './assets/ag-grid-overrides.css';
import { AgGridVue } from "ag-grid-vue3";
import BtnCellRenderer from "@/components/dataTable/btn-cell-renderer.vue";
import CheckCellRenderer from "@/components/dataTable/check-cell-renderer.vue";
import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6");
import moment from 'moment'

const app = createApp(App);
app.use(router);
app.use(store);
app.use(VueTheMask);

export const epochTime = function (date) {
  var time = null;
  if (date != null && date != '') {
    time = new Date(date).getTime() / 1000;
  }
  return time;
}
export const exchangeCurrency = function (currency, currentCode, price, exchange, baseCode = "RUB") {
  try {
    var exchangePrice = price;
    if (exchange != currentCode) {
      if (currentCode != baseCode) {
        exchangePrice = exchangePrice * currency[baseCode];
      }
      exchangePrice = exchangePrice / currency[exchange];
    }
    return parseFloat(exchangePrice.toFixed(2));
  } catch {
    return price;
  }
}
export const tableToExcel = function (table, style, name) {
  var nowDate = new Date();
  let tableData = table.outerHTML;
  tableData = tableData.replace(/<A[^>]*>|<\/A>/g, "");
  tableData = tableData.replace(/<input[^>]*>|<\/input>/gi, "");
  let a = document.createElement('a')
  // let dataType = 'data:application/vnd.ms-excel';
  a.href = `data:application/vnd.ms-excel, ${encodeURIComponent('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><style>' + style.textContent + '</style>' + tableData + '</body></html>')}`
  a.download = name + '(' + nowDate.getDate() + '-' + (nowDate.getMonth() + 1) + "-" + nowDate.getFullYear() + ' ' + nowDate.getHours() + '-' + nowDate.getMinutes() + '-' + nowDate.getSeconds() + ').xls'
  a.click();
}

export const diffToGMT = function (date) {
  let diff = new Date().getTimezoneOffset();
  return new Date(date).setMinutes(new Date(date).getMinutes() - diff);
}


export const burcHesaplama = function (date) {
  let birthDate = (new Date(date).getMonth() + 1).toString()
  if (new Date(date).getDate().toString().length == 1) {
    birthDate = birthDate + "0";
  }
  birthDate += new Date(date).getDate();
  birthDate = parseInt(birthDate);
  if (birthDate >= 321 && birthDate <= 420) {
    return "Koç"
  }
  else if (birthDate >= 421 && birthDate <= 520) {
    return "Boğa"
  }
  else if (birthDate >= 521 && birthDate <= 621) {
    return "İkizler"
  }
  else if (birthDate >= 622 && birthDate <= 722) {
    return "Yengeç"
  }
  else if (birthDate >= 723 && birthDate <= 823) {
    return "Aslan"
  }
  else if (birthDate >= 824 && birthDate <= 923) {
    return "Başak"
  }
  else if (birthDate >= 924 && birthDate <= 1022) {
    return "Terazi"
  }
  else if (birthDate >= 1024 && birthDate <= 1122) {
    return "Akrep"
  }
  else if (birthDate >= 1123 && birthDate <= 1221) {
    return "Yay"
  }
  else if (birthDate <= 1222 && birthDate <= 120) {
    return "Oğlak"
  }
  else if (birthDate >= 121 && birthDate <= 219) {
    return "Kova"
  }
  else {
    return "Balık"
  }
}

app.component("loadArea", loadArea);
app.component("ValidationProvider", ValidationProvider);
app.component("Form", Form);
app.component("Field", Field);
app.component("ErrorMessage", ErrorMessage);
app.component("dataTable", dataTable);
app.component("AgGridVue", AgGridVue);
app.component("cardHead", cardHead);
app.component("formGroup", formGroup);
app.component("formGroupTag", formGroupTag);
app.component("searchSelect", searchSelect);
app.component("Btn", Button);
app.component("modal", modal);
app.use(VueSweetalert2);
app.use(Maska);

import vClickOutside from "click-outside-vue3"
app.directive("clickOutside", vClickOutside.directive)

app.config.globalProperties.$appAxios = appAxios;
app.config.globalProperties.$appAxiosAdmin = appAxiosAdmin;
app.config.globalProperties.$appAxiosTourscope = appAxiosTourscope;
app.config.globalProperties.$appAxiosKolayrez = appAxiosKolayrez;
app.config.globalProperties.$appAxiosOther=appAxiosOther;
app.config.globalProperties.$createDataTable = createDataTable;
app.config.globalProperties.$searchColumnArray = searchColumnArray;
app.config.globalProperties.$searchArray = searchArray;
app.config.globalProperties.$orderByArray = orderByArray;
app.config.globalProperties.$turkishReplaces = turkishReplaces;
app.config.globalProperties.$isError = isError;
app.config.globalProperties.$dateFormat = dateFormat;
app.config.globalProperties.$epochTime = epochTime;
app.config.globalProperties.$formatPrice = formatPrice;
app.config.globalProperties.$BtnCellRenderer = BtnCellRenderer;
app.config.globalProperties.$CheckCellRenderer = CheckCellRenderer;
app.config.globalProperties.$burcHesaplama = burcHesaplama;
app.config.globalProperties.$uniqueid = uniqueid;
app.config.globalProperties.$exchangeCurrency = exchangeCurrency;
app.config.globalProperties.$tableToExcel = tableToExcel;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$Toastify = Toastify;
app.config.globalProperties.$diffToGMT = diffToGMT;
app.mount('#app');

